
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#AA494A","d":"M1 11h62v42H1z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M12 21.686l2.163 4.383 4.837.703-3.5 3.411.826 4.817L12 32.726 7.674 35l.826-4.817L5 26.772l4.837-.703zM23 14.884l.831 1.684 1.859.27-1.345 1.311.318 1.851L23 19.126 21.337 20l.318-1.851-1.345-1.311 1.859-.27zM23 38l.831 1.685 1.859.269-1.345 1.312.318 1.85L23 42.242l-1.663.874.318-1.85-1.345-1.312 1.859-.269zM27.69 22l.832 1.685 1.858.269-1.345 1.312.318 1.85-1.663-.874-1.663.874.318-1.85L25 23.954l1.859-.269zM27.69 30.116l.832 1.685 1.858.27-1.345 1.311.318 1.851-1.663-.874-1.663.874.318-1.851L25 32.071l1.859-.27z"}})])
          )
        }
      }
    